(function () {
  'use strict';

  const modal   = document.getElementById('size-chart-modal');
  if (!modal) return;

  const overlay = modal.querySelector('.sc-modal__overlay');
  const closeBtn = modal.querySelector('.sc-modal__close');

  // ── Open ──
  function openModal(triggerEl) {
    activateTab('mens');

    modal.removeAttribute('hidden');
    document.body.classList.add('sc-no-scroll');
    closeBtn.focus();
  }

  // ── Close ──
  function closeModal() {
    modal.setAttribute('hidden', '');
    document.body.classList.remove('sc-no-scroll');
  }

  // ── Tab switching ──
  function activateTab(tabKey) {
    modal.querySelectorAll('.sc-tab').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabKey);
    });
    modal.querySelectorAll('.sc-panel').forEach(panel => {
      panel.classList.toggle('active', panel.dataset.panel === tabKey);
    });
  }

  // ── Event delegation ──
  document.addEventListener('click', function (e) {
    // Trigger button (product page)
    const trigger = e.target.closest('.sc-trigger');
    if (trigger) {
      e.preventDefault();
      openModal(trigger);
      return;
    }

    // Anchor link trigger (FAQ page and anywhere else)
    const anchorLink = e.target.closest('a[href="#size-chart"]');
    if (anchorLink) {
      e.preventDefault();
      openModal(null);
      return;
    }

// Click outside dialog
if (e.target.closest('#size-chart-modal') && !e.target.closest('.sc-modal__dialog')) {
  closeModal();
  return;
}

    // Close button
    if (e.target.closest('.sc-modal__close')) {
      closeModal();
      return;
    }

    // Tab click
    const tab = e.target.closest('.sc-tab');
    if (tab && modal.contains(tab)) {
      activateTab(tab.dataset.tab);
      return;
    }
  });

  // ── Escape key ──
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
      closeModal();
    }
  });

})();
